import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "overlay"]

  initialize () {
    this.body = document.body
    this.isOpen = false
  }

  toggle (event) {
    event.preventDefault()
    this.isOpen = !this.isOpen
    this.updateDom()
  }

  close () {
    this.isOpen = false
    this.updateDom()
  }

  updateDom () {
    if (this.hasPanelTarget) {
      this.panelTarget.classList.toggle("translate-x-full", !this.isOpen)
      this.panelTarget.classList.toggle("translate-x-0", this.isOpen)
      this.panelTarget.classList.toggle("in", this.isOpen)
    }

    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.toggle("opacity-0", !this.isOpen)
      this.overlayTarget.classList.toggle("pointer-events-none", !this.isOpen)
      this.overlayTarget.classList.toggle("opacity-100", this.isOpen)
      this.overlayTarget.classList.toggle("pointer-events-auto", this.isOpen)
    }

    this.body.classList.toggle("overflow-hidden", this.isOpen)
  }
}
